import 'core-js/web/url-search-params';
import React from 'react';
import ReactDOM from 'react-dom';

import { GTM_ID } from './config';
import App from './App';
import * as api from './services/api';
import { captureMsclkidFromUrl } from './utils/msclkid';
import { createShadowMount } from './utils/shadowMount';
import './styles/reset.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import TagManager from 'react-gtm-module';

function checkCookieExists(cookieName: any) {
  // Split the cookie string into individual cookies
  var cookies = document.cookie.split(';');

  // Iterate over the cookies and check if the cookieName is found
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();

    // Check if the cookie starts with the provided cookieName
    if (cookie.indexOf(cookieName + '=') === 0) {
      // Cookie found
      return true;
    }
  }

  // Cookie not found
  return false;
}
const tagManagerArgs = {
  gtmId: GTM_ID
}

TagManager.initialize(tagManagerArgs);

// Capture the Microsoft Ads click id (?msclkid=) from the landing URL into a
// first-party cookie so it can be attached to server-side purchase conversions.
captureMsclkidFromUrl();

//check token exist
var cookieExists = checkCookieExists('XSRF-TOKEN');

async function loadSuburbs(cookieExists: any) {
  //Fetch suburbs data from local storage
  var version = localStorage.getItem("suburbs_version");
  var suburbs = localStorage.getItem("suburbs");

  //Check if version or suburbs not set
  if (!version || !suburbs) {
    version = null;
  }

  //Call token api
  if (!cookieExists) {
    await api.csrf();
  }

  try {
    let response = await api.post<any>(`/suburbs-version`, { version: version });

    if (response.data) {
      //Sets version and suburbs in local storage
      localStorage.setItem("suburbs_version", response.data.version);
      localStorage.setItem("suburbs", JSON.stringify(response.data.suburbs));
    }
  } catch (e) {
    await api.csrf();
    let response = await api.post<any>(`/suburbs-version`, { version: version });

    if (response.data) {
      //Sets version and suburbs in local storage
      localStorage.setItem("suburbs_version", response.data.version);
      localStorage.setItem("suburbs", JSON.stringify(response.data.suburbs));
    }
  }

}
loadSuburbs(cookieExists);

// Holds the active shadow root (when shadow mode is on) so overlays/dropdowns
// can portal inside the boundary instead of document.body. Null in legacy mode.
(window as any).__fcShadowRoot = null;

// Dev-only widget preview. Append ?widget=<data-type> (e.g. tracking, vertical,
// horizontal, courier-reviews) to mount that single widget with shadow
// isolation, mimicking the WordPress embed without a WP site. Off in production.
const previewType =
  process.env.NODE_ENV !== 'production'
    ? new URLSearchParams(window.location.search).get('widget')
    : null;

if (previewType) {
  const host = document.createElement('div');
  host.setAttribute('data-fast-courier-app', '');
  host.setAttribute('data-type', previewType);
  host.setAttribute('data-shadow', 'true');

  // Light page backdrop + centered column, roughly matching a WordPress page.
  const wrap = document.createElement('div');
  wrap.style.cssText = 'background:#f3f4f6;min-height:100vh;padding:40px 16px;';
  const inner = document.createElement('div');
  inner.style.cssText = 'max-width:900px;margin:0 auto;';
  inner.appendChild(host);
  wrap.appendChild(inner);
  document.body.innerHTML = '';
  document.body.appendChild(wrap);

  const { mountNode, shadowRoot } = createShadowMount(host);
  (window as any).__fcShadowRoot = shadowRoot;
  ReactDOM.render(<App type={previewType as any} appPageUrl="" />, mountNode);
}

if (!previewType) {
  document.querySelectorAll('[data-fast-courier-app]').forEach((element) => {
    const type = (element.getAttribute('data-type') ?? 'horizontal') as 'horizontal' | 'vertical' | 'app';
    const appPageUrl = (element.getAttribute('data-app-page-url') ?? '') as string;

    // Opt-in Shadow DOM isolation via data-shadow="true". When enabled, the host
    // page's theme/plugin CSS can no longer reach into the widget.
    const useShadow = (element.getAttribute('data-shadow') ?? '').toLowerCase() === 'true';

    if (useShadow) {
      const { mountNode, shadowRoot } = createShadowMount(element as HTMLElement);
      (window as any).__fcShadowRoot = shadowRoot;
      ReactDOM.render(<App type={type} appPageUrl={appPageUrl} />, mountNode);
    } else {
      ReactDOM.render(<App type={type} appPageUrl={appPageUrl} />, element);
    }
  });
}
